<template>
    <div style="position: fixed; width: 1920px; top: -15px; left: 0">
        <div v-if="spiel">
            <div class="tableContainer">
                <table style="min-width: 860px; border: none" class="white">
                    <tr style="vertical-align: top">
                        <td class="px-2 pb-2" style="width: 50%; border: none">
                            <tv-display-team :data-object="spiel" type="heim" :tvMode="true">
                            </tv-display-team>
                        </td>
                        <td class="px-2 pb-2" style="width: 50%; border: none">
                            <tv-display-team :data-object="spiel" type="gast" :tvMode="true">
                            </tv-display-team>
                        </td>
                    </tr>
                </table>
                <div class="px-2 pb-5 pt-4">
                    <table style="border-right: solid 1px grey; border-bottom: solid 1px grey"
                            class="text-center">
                        <tr :class="tvModeTextHeader">
                            <td class="px-3">Schnitt</td>
                            <td class="px-3"><span v-if="isCup">FW</span><span v-else>Gesamtkegel</span></td>
                            <td class="px-3"><span v-if="isCup">Abräumen</span><span v-else>SaP</span></td>
                            <td class="px-3"><span v-if="isCup">Gesamtkegel</span><span v-else>Diff.</span></td>
                            <td colspan="3" class="px-3">Endergebnis</td>
                            <td class="px-3"><span v-if="isCup">Gesamtkegel</span><span v-else>Diff.</span></td>
                            <td class="px-3"><span v-if="isCup">Abräumen</span><span v-else>SaP</span></td>
                            <td class="px-3"><span v-if="isCup">FW</span><span v-else>Gesamtkegel</span></td>
                            <td class="px-3">Schnitt</td>
                        </tr>
                        <tr :class="tvModeText">
                            <td :class="spiel.getCSSColor('heim', 'schnitt',
                                        ['font-weight-bold text-truncate mb-1'])">
                                {{spiel.heim.result.schnitt}}
                            </td>
                            <td :class="spiel.getCSSColor('heim', 'kegel',
                                        ['font-weight-bold text-truncate mb-1'])">
                                <span v-if="isCup">{{spiel.heim.result.fw}}</span>
                                <span v-else>{{spiel.heim.result.kegel}}</span>
                            </td>
                            <td :class="spiel.getCSSColor('heim', 'sp',
                                        ['font-weight-bold text-truncate mb-1'])">
                                <span v-if="isCup">{{spiel.heim.result.ar}}</span>
                                <span v-else>{{spiel.heim.result.sp}}</span>
                            </td>
                            <td :class="spiel.getCSSColor('heim', 'kegel',
                                        ['font-weight-bold text-truncate mb-1'])">
                                <span v-if="isCup">{{spiel.heim.result.kegel}}</span>
                                <span v-else>{{spiel.heim.result.kegel - spiel.gast.result.kegel}}</span>
                            </td>
                            <td :class="spiel.getCSSColor('heim', 'tabPkt',
                                        ['font-weight-bold text-truncate mb-1'])">
                                <span v-if="isCup">{{spiel.getKegelDeltaSign('heim')}}</span>
                                <span v-else>{{spiel.heim.result.mp}}</span>
                            </td>
                            <td>
                                <span v-if="isCup">{{Math.abs(spiel.heim.result.kegel - spiel.gast.result.kegel)}}</span>
                                <span v-else>:</span>
                            </td>
                            <td :class="spiel.getCSSColor('gast', 'tabPkt',
                                        ['font-weight-bold text-truncate mb-1'])">
                                <span v-if="isCup">{{spiel.getKegelDeltaSign('gast')}}</span>
                                <span v-else>{{spiel.gast.result.mp}}</span>
                            </td>
                            <td :class="spiel.getCSSColor('gast', 'kegel',
                                        ['font-weight-bold text-truncate mb-1'])">
                                <span v-if="isCup">{{spiel.gast.result.kegel}}</span>
                                <span v-else>{{spiel.gast.result.kegel - spiel.heim.result.kegel}}</span>
                            </td>
                            <td :class="spiel.getCSSColor('gast', 'sp',
                                        ['font-weight-bold text-truncate mb-1'])">
                                <span v-if="isCup">{{spiel.gast.result.ar}}</span>
                                <span v-else>{{spiel.gast.result.sp}}</span>
                            </td>
                            <td :class="spiel.getCSSColor('gast', 'kegel',
                                        ['font-weight-bold text-truncate mb-1'])">
                                <span v-if="isCup">{{spiel.gast.result.fw}}</span>
                                <span v-else>{{spiel.gast.result.kegel}}</span>
                            </td>
                            <td :class="spiel.getCSSColor('gast', 'schnitt',
                                        ['font-weight-bold text-truncate mb-1'])">
                                {{spiel.gast.result.schnitt}}
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="px-2 pb-2">
                    <table style="border-right: solid 1px grey; border-bottom: solid 1px grey"
                           class="text-center">
                        <tr :class="tvModeText">
                            <td style="width: 33.33%"><span class="font-weight-bold">Kapitän/in Heim</span>
                                <br>{{spiel.heim.captain}}</td>
                            <td style="width: 33.33%"><span class="font-weight-bold">Schiedsrichter</span>
                                <br>{{spiel.referee.name}}</td>
                            <td style="width: 33.33%">
                                <span class="font-weight-bold">Kapitän/in Gast</span><br>
                                {{spiel.gast.captain}}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { db } from '../../../../services/db'
    import {Spiel} from "../../../../services/data/spiel";
    import TvDisplayTeam from "./tvDisplayTeam";

    export default {
        components: {TvDisplayTeam,},
        name: "tv-display-tab",
        data: () => ({
            spiel: null,
            spielRaw: null,
            landesverband: null,
        }),
        computed: {
            isCup(){ return this.spiel.saison.isCup},
            liga(){
                return this.spiel && this.landesverband ?
                    this.landesverband.ligen[this.spiel.getLigaId()].nameFull : '';
            },
            tvModeTextHeader(){
                return ['lgTV font-weight-bold grey lighten-3'];
                /*return [{'smTV font-weight-bold grey lighten-3': this.$vuetify.breakpoint.smOnly},
                    {'mdTV font-weight-bold grey lighten-3': this.$vuetify.breakpoint.mdOnly},
                    {'lgTV font-weight-bold grey lighten-3': this.$vuetify.breakpoint.lgOnly},
                    {'xlTV font-weight-bold grey lighten-3': this.$vuetify.breakpoint.xlOnly},
                ]*/
            },
            tvModeText(){
                return 'lgTV'
                /*return [{'smTV': this.$vuetify.breakpoint.smOnly},
                    {'mdTV': this.$vuetify.breakpoint.mdOnly},
                    {'lgTV': this.$vuetify.breakpoint.lgOnly},
                    {'xlTV': this.$vuetify.breakpoint.xlOnly},
                ]*/
            },
        },
        created(){
            this.setSpielRaw();
            //window.print();
        },
        mounted () {
            document.body.classList.add('hideScrollbar')
        },
        destroyed () {
            document.body.classList.remove('hideScrollbar')
        },
        methods: {
            setSpielRaw(){
                db.collection("spiele").doc(this.$route.query.id)
                    .onSnapshot((doc) => {
                        this.spielRaw = doc.data();
                        this.spielRaw.id = doc.id;
                    });
            },
            setSpiel(){
                this.spiel = new Spiel();
                this.spiel.setFromDataObject(this.spielRaw);
                this.setLandesverband();
            },
            setLandesverband(){
                db.collection("landesverbaende").doc(this.spiel.saison.lvId).get()
                    .then((doc) => {
                        if (doc.exists) {
                            console.log("Document data:", doc.data());
                            this.landesverband = doc.data();
                        } else {
                            // doc.data() will be undefined in this case
                            console.log("No such document!");
                        }
                    }).catch((error) => {
                    console.log("Error getting document:", error);
                });
            }
        },
        watch: {
            spielRaw: {
                handler(){
                    this.setSpiel();
                },
                deep: true
            },
        }
    }
</script>

<style scoped>
    td { border: solid 1px black;}
    .tableContainer { width: 100%;}
    .borderTop {border-top: solid 1px lightgrey;}
    table {width: 100%; border-spacing: 0; table-layout: auto; border: solid 1px black  }
    .smTV { font-size: 18px; height: 50px; font-family: Roboto }
    .mdTV { font-size: 24px; height: 66px; font-family: Roboto }
    .lgTV { font-size: 26px; height: 80px; font-family: Roboto }
    .xlTV { font-size: 48px; height: 100px; font-family: Roboto }
</style>